import LegalPage from "./LegalPage";

function PrivacyPage() {
  return (
    <LegalPage
      slug="privacy"
      title="Privacy Policy | Vocally"
      description="Learn how Vocally collects, processes, and protects information across our local-first AI dictation platform."
    />
  );
}

export default PrivacyPage;
